import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/lease/Screen';
import { BrandHeading } from '../../components/lease/BrandHeading';
import { PrimaryButton } from '../../components/lease/PrimaryButton';

// Mockup "11c Thank You - End": the terminal resting place of the journey —
// fixes "user stranded after download" by always giving a next step.
export function ThankYou() {
  const navigate = useNavigate();

  return (
    <Screen>
      <header className="animate-fade-in text-center">
        <BrandHeading className="text-4xl">Thank You!</BrandHeading>
        <p className="mt-3 text-slate-600 dark:text-slate-300">
          Your lease review is complete.
        </p>
        <p className="mt-3 text-slate-600 dark:text-slate-300">
          We hope LeaseCheck helped you understand your lease and feel ready
          to sign with confidence.
        </p>
      </header>

      <PrimaryButton onClick={() => navigate('/dashboard')} className="mt-8 animate-slide-in">
        Back to dashboard
      </PrimaryButton>
    </Screen>
  );
}

export default ThankYou;
